import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import Layout from '../components/Layout'
import Home from '../views/home/index.vue'
import Dialogue from '../views/dialogue/index.vue'
import My from '../views/my/index.vue'
import { toLogin } from '@/utils/baseConfig'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/layout',
  },
  {
    path: '/layout',
    name: 'layout',
    redirect: '/layout/home',
    component: Layout,
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          keepAlive: true
        },
        component: Home,
      },
      {
        path: 'dialogue',
        name: 'dialogue',
        meta: {
          keepAlive: true
        },
        component: Dialogue,
      },
      {
        path: 'my',
        name: 'my',
        meta: {
          keepAlive: true
        },
        component: My,
      }
    ]
  },

  {
    // 登录
    path: '/login',
    name: 'login',
    component: () => import( /* webpackChunkName: "login" */ '@/views/login/index.vue')
  },
  {
    // 问卷
    path: '/survey',
    name: 'survey',
    component: () => import( /* webpackChunkName: "survey" */ '@/views/survey/index.vue')
  },
  // 量表报告
  {
    path: '/scaleReport',
    name: 'scaleReport',
    component: () => import( /* webpackChunkName: "scaleReport" */ '@/views/scaleReport/index.vue')
  },
  // 量表报告
  {
    path: '/scaleReportMain',
    name: 'scaleReportMain',
    component: () => import( /* webpackChunkName: "scaleReportMain" */ '@/views/scaleReportMain/index.vue')
  },
  // 对策卡
  {
    path: '/countermeasureCard',
    name: 'countermeasureCard',
    component: () => import( /* webpackChunkName: "countermeasureCard" */ '@/views/countermeasureCard/index.vue')
  },
  // 情绪评分
  {
    path: '/emotionalScore',
    name: 'emotionalScore',
    component: () => import( /* webpackChunkName: "emotionalScore" */ '@/views/emotionalScore/index.vue')
  },
  // 治疗日历
  {
    path: '/treatmentCalendar',
    name: 'treatmentCalendar',
    component: () => import( /* webpackChunkName: "treatmentCalendar" */ '@/views/treatmentCalendar/index.vue')
  },
  // 目标与动机
  {
    path: '/problemGoalMotive',
    name: 'problemGoalMotive',
    component: () => import( /* webpackChunkName: "problemGoalMotive" */ '@/views/problemGoalMotive/index.vue')
  },
  // 工具箱
  {
    path: '/tools',
    name: 'tools',
    component: () => import( /* webpackChunkName: "tools" */ '@/views/tools/index.vue')
  },
  // 情绪识别
  {
    path: '/emotionalRecognition',
    name: 'emotionalRecognition',
    component: () => import( /* webpackChunkName: "emotionalRecognition" */ '@/views/emotionalRecognition/index.vue')
  },
  // 心情评分
  {
    path: '/currentEmotionalRating',
    name: 'currentEmotionalRating',
    component: () => import( /* webpackChunkName: "currentEmotionalRating" */ '@/views/currentEmotionalRating/index.vue')
  },
  // 思维陷阱（12种心理歪曲）
  {
    path: '/psychologicalDistortion',
    name: 'psychologicalDistortion',
    component: () => import( /* webpackChunkName: "psychologicalDistortion" */ '@/views/psychologicalDistortion/index.vue')
  },
  // 自动化思维识别
  {
    path: '/automatedMindRecognition',
    name: 'automatedMindRecognition',
    component: () => import( /* webpackChunkName: "automatedMindRecognition" */ '@/views/automatedMindRecognition/index.vue')
  },
  // 自动化思维列表
  {
    path: '/automatedMindRecognitionList',
    name: 'automatedMindRecognitionList',
    component: () => import( /* webpackChunkName: "automatedMindRecognitionList" */ '@/views/automatedMindRecognitionList/index.vue')
  },
  // 自动化思维报告
  {
    path: '/automaticThinkingReport/:id',
    name: 'automaticThinkingReport',
    component: () => import( /* webpackChunkName: "automaticThinkingReport" */ '@/views/automaticThinkingReport/index.vue')
  },
  // 活动计划
  {
    path: '/activityPlan',
    name: 'activityPlan',
    component: () => import( /* webpackChunkName: "activityPlan" */ '@/views/activityPlan/index.vue')
  },
  // 添加 活动计划
  {
    path: '/addActivityPlan',
    name: 'addActivityPlan',
    component: () => import( /* webpackChunkName: "addActivityPlan" */ '@/views/addActivityPlan/index.vue')
  },
  // 量表报告
  {
    path: '/reportDetails/:id',
    name: 'reportDetails',
    component: () => import( /* webpackChunkName: "reportDetails" */ '@/views/reportDetails/index.vue')
  },
  // 目标与动机 修改
  {
    path: '/problemGoalMotiveEdit',
    name: 'problemGoalMotiveEdit',
    component: () => import( /* webpackChunkName: "problemGoalMotiveEdit" */ '@/views/problemGoalMotiveEdit/index.vue')
  },
  // 愉悦活动清单
  {
    path: '/activityList',
    name: 'activityList',
    component: () => import( /* webpackChunkName: "activityList" */ '@/views/activityList/index.vue')
  },
  // 认知重建
  {
    path: '/cognitiveReconstruction',
    name: 'cognitiveReconstruction',
    component: () => import( /* webpackChunkName: "cognitiveReconstruction" */ '@/views/cognitiveReconstruction/index.vue')
  },
    // 认知重建list
  {
    path: '/cognitiveReconstructionList',
    name: 'cognitiveReconstructionList',
    component: () => import( /* webpackChunkName: "cognitiveReconstructionList" */ '@/views/cognitiveReconstructionList/index.vue')
  },
  // 认知重建报告
  {
    path: '/cognitiveReconstructionReport/:id',
    name: 'cognitiveReconstructionReport',
    component: () => import( /* webpackChunkName: "cognitiveReconstructionReport" */ '@/views/cognitiveReconstructionReport/index.vue')
  },
    // 放松训练
  {
    path: '/relaxationTraining',
    name: 'relaxationTraining',
    component: () => import( /* webpackChunkName: "relaxationTraining" */ '@/views/relaxationTraining/index.vue')
  },
    // 添加对策卡
  {
    path: '/addCountermeasureCard',
    name: 'addCountermeasureCard',
    component: () => import( /* webpackChunkName: "addCountermeasureCard" */ '@/views/addCountermeasureCard/index.vue')
  },
    // 对策卡详情
  {
    path: '/countermeasureCardDetails/:id',
    name: 'countermeasureCardDetails',
    component: () => import( /* webpackChunkName: "countermeasureCardDetails" */ '@/views/countermeasureCardDetails/index.vue')
  },
    // 初步评估
  {
    path: '/surveyDialogue',
    name: 'surveyDialogue',
    component: () => import( /* webpackChunkName: "surveyDialogue" */ '@/views/surveyDialogue/index.vue')
  },
  // 行为活动计划 对话
  {
    path: '/behaviourExercisePlan',
    name: 'behaviourExercisePlan',
    component: () => import( /* webpackChunkName: "behaviourExercisePlan" */ '@/views/behaviourExercisePlan/index.vue')
  },
  // 愉悦列表 对话
  {
    path: '/happlyActivityList',
    name: 'happlyActivityList',
    component: () => import( /* webpackChunkName: "happlyActivityList" */ '@/views/happlyActivityList/index.vue')
  },
  // 对应卡
  {
    path: '/dealWithThe',
    name: 'dealWithThe',
    component: () => import( /* webpackChunkName: "dealWithThe" */ '@/views/dealWithThe/index.vue')
  },
  // 对应卡片
  {
    path: '/dealWithTheCard',
    name: 'dealWithTheCard',
    component: () => import( /* webpackChunkName: "dealWithTheCard" */ '@/views/dealWithTheCard/index.vue')
  },
  // 自动化思维识别 二级页面
  {
    path: '/automatedMindRecognitionDetails',
    name: 'automatedMindRecognitionDetails',
    component: () => import( /* webpackChunkName: "automatedMindRecognitionDetails" */ '@/views/automatedMindRecognition/details.vue')
  },
  // 心情日记
  {
    path: '/emotionalDiary',
    name: 'emotionalDiary',
    component: () => import( /* webpackChunkName: "emotionalDiary" */ '@/views/emotionalDiary/index.vue')
  },
  // 情绪识别
  {
    path: '/emotionRecognitionAndNaming',
    name: 'emotionRecognitionAndNaming',
    component: () => import( /* webpackChunkName: "emotionRecognitionAndNaming" */ '@/views/emotionRecognitionAndNaming/index.vue')
  },
  // 添加自动化思维 选择页面
  {
    path: '/automatedMindRecognitionSelect',
    name: 'automatedMindRecognitionSelect',
    component: () => import( /* webpackChunkName: "automatedMindRecognitionSelect" */ '@/views/automatedMindRecognitionEdit/indexSelect.vue')
  },
  // 修改自动化思维
  {
    path: '/automatedMindRecognitionEdit',
    name: 'automatedMindRecognitionEdit',
    component: () => import( /* webpackChunkName: "automatedMindRecognitionEdit" */ '@/views/automatedMindRecognitionEdit/index.vue')
  },
  // 思维陷阱 修改
  {
    path: '/psychologicalDistortionEdit',
    name: 'psychologicalDistortionEdit',
    component: () => import( /* webpackChunkName: "psychologicalDistortionEdit" */ '@/views/psychologicalDistortionEdit/index.vue')
  },
  // 认知重建 修改
  {
    path: '/cognitiveReconstructionEdit',
    name: 'cognitiveReconstructionEdit',
    component: () => import( /* webpackChunkName: "cognitiveReconstructionEdit" */ '@/views/cognitiveReconstructionEdit/index.vue')
  },
  // 目标完成情况
  {
    path: '/goalCompletionStatus',
    name: 'goalCompletionStatus',
    component: () => import( /* webpackChunkName: "goalCompletionStatus" */ '@/views/goalCompletionStatus/index.vue')
  },
  // 大语言模型
  {
    path: '/automatedThinkingAI',
    name: 'automatedThinkingAI',
    component: () => import( /* webpackChunkName: "automatedThinkingAI" */ '@/views/automatedThinkingAI/index.vue')
  },
  // 隐私政策 服务协议
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import( /* webpackChunkName: "privacyPolicy" */ '@/views/privacyPolicy/index.vue')
  },
  // 对策卡对话
  {
    path: '/countermeasurecardDialogue',
    name: 'countermeasurecardDialogue',
    component: () => import( /* webpackChunkName: "countermeasurecardDialogue" */ '@/views/countermeasurecardDialogue/index.vue')
  },
  // 对策卡对话2
  {
    path: '/countermeasurecardDialogue/addCountermeasureCard',
    name: 'addCountermeasureCard2',
    component: () => import( /* webpackChunkName: "addCountermeasureCard2" */ '@/views/countermeasurecardDialogue/addCountermeasureCard.vue')
  },
  // 案例联系
  {
    path: '/caseStudy',
    name: 'caseStudy',
    component: () => import( /* webpackChunkName: "caseStudy" */ '@/views/caseStudy/index.vue')
  },
  {
    path: '/componentView',
    name: 'componentView',
    component: () => import( /* webpackChunkName: "componentsView" */ '@/views/componentView/index.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import( /* webpackChunkName: "404" */ '@/views/error/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  // mode: 'history', // 尝试使用history模式
  mode: 'hash', // hash
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { y: 0 }
    }
  },
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => !!record.meta.requiresAuth);
  const isAuthenticated = !!getToken();

  if (requiresAuth && !isAuthenticated) {
    // 如果访问的路由需要 Token，但用户没有登录，则重定向到登录页面
    toLogin()
    // next();
  } else if (to.path === '/login' && isAuthenticated) {
    // 如果用户已经登录，但尝试访问登录页面，则重定向到主页
    next('/');
  } else {
    next(); // 确保总是调用 next()
  }
});

export default router